import { ThesaurusDataStore, ThesaurusTermDataStore } from '@skinsoft/entity';
import { ReactiveVue } from '@skinsoft/reactive-vue';

import { mergeMap } from 'rxjs/operators';
import { Component, Watch } from 'vue-property-decorator';

import { ThesaurusTermSelectField } from '../thesaurus-term-select-field';

@Component({
    components: {
        sThesaurusTermSelectField: ThesaurusTermSelectField,
    },
    props: ['identifier'],
    template: require('./thesaurus-select-field.html'),
})
export class ThesaurusSelectField extends ReactiveVue {
    public $thesaurusDataStore: ThesaurusDataStore;
    public $thesaurusTermDataStore: ThesaurusTermDataStore;
    public identifier: string;

    public id: string = null as any;

    public mounted() {
        this.subscribeToThesaurus();
    }

    public beforeDestroy() {
        this.unsubscribeFrom('thesaurus');
    }

    public subscribeToThesaurus() {
        this.subscribeTo(
            this.$thesaurusDataStore.fetchOne(this.identifier).pipe(
                mergeMap(thesaurus => {
                    return this.$thesaurusTermDataStore.fetchRoot(thesaurus.id);
                }),
            ),
            thesaurusTerms => {
                this.id = thesaurusTerms[0].id;
            },
            'thesaurus',
        );
    }

    @Watch('identifier', { immediate: true })
    private onIdentifierChange() {
        this.unsubscribeFrom('thesaurus');
        if (this.identifier) {
            this.subscribeToThesaurus();
        }
    }
}
